import React from "react";
import PropTypes from "prop-types";
import { LabeledInputComponent } from "./LabeledInputComponent";

export const LabeledSelect = ({
  onChange,
  value,
  label,
  id,
  description,
  options,
  placeholder = null,
  inputProps = null,
}) => (
  <LabeledInputComponent id={id} label={label} description={description}>
    <select
      onChange={(event) =>
        onChange(event.target.value === "" ? null : event.target.value)
      }
      value={value === null ? "" : value}
      {...inputProps}
    >
      {placeholder ? <option value="">{placeholder}</option> : null}
      {options.map(({ value, label }) => (
        <option key={value} value={value}>
          {label || value}
        </option>
      ))}
    </select>
  </LabeledInputComponent>
);

LabeledSelect.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  description: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string,
    })
  ).isRequired,
  placeholder: PropTypes.string,
};
